import { styled } from '@mui/material';
import { Link } from 'react-router';
import getColor, { Color } from 'utils/getColor';

export const LinkStyled = styled(Link, {
  shouldForwardProp: (prop: string) =>
    !['$color', '$isNotificationLink'].includes(prop)
})<{
  $color?: Color;
  $isNotificationLink?: boolean;
}>`
  text-decoration: none;
  ${({ $color }) => $color && `color: ${getColor($color)};`}
  ${({ $isNotificationLink }) => $isNotificationLink && `&&& { padding: 0; }`}
`;
